// 引入 axios
import axios from "axios";

let BASEURL = 'http://8.141.121.33:8888/portal';
const IMAGE_URL = "http://8.141.121.33:8888"

//传送json格式的get请求
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${BASEURL}${url}`,
        data: params,
    })
}
export const imageTran = (path) => IMAGE_URL + path
